import { call, put, takeEvery } from 'redux-saga/effects';
import {
  editProfileRequest,
  editProfileSuccess,
  editProfileFailure,
  getAdminProfileSuccess,
  getAdminProfileFailure
} from '../actions/profileActions';
import { setUser } from '../actions/authActions';
import { profileApi } from '../../api/profileApi';
import { toast } from 'react-toastify';

function* editProfileSaga(action) {
  try {
    yield put(editProfileRequest());
    const response = yield call(profileApi.editProfile, action.payload);
    
    yield put(editProfileSuccess(response.response));
    yield put(setUser(response.response));
    
    // Update sessionStorage with new user data
    const existingUser = JSON.parse(sessionStorage.getItem('user') || '{}');
    const updatedUser = { ...existingUser, ...response.response };
    sessionStorage.setItem('user', JSON.stringify(updatedUser));
    
    toast.success('Profile updated successfully!');
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Profile update failed';
    yield put(editProfileFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* getAdminProfileSaga(action) {
  try {
    yield put({ type: 'GET_ADMIN_PROFILE_REQUEST' });
    const response = yield call(profileApi.getAdminProfile, action.payload);
    yield put(getAdminProfileSuccess(response.response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch profile';
    yield put(getAdminProfileFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* updateLogoSaga(action) {
  try {
    yield put(editProfileRequest());
    const response = yield call(profileApi.updateLogo, action.payload);
    
    // Refresh profile data to get updated logo
    const profileResponse = yield call(profileApi.getAdminProfile, action.payload.userId);
    yield put(getAdminProfileSuccess(profileResponse.response));
    yield put(editProfileSuccess(response.response));
    
    toast.success('Logo updated successfully!');
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Logo update failed';
    yield put(editProfileFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* resetPasswordSaga(action) {
  try {
    yield put(editProfileRequest());
    const response = yield call(profileApi.resetPassword, action.payload);
    yield put(editProfileSuccess(response.response));
    toast.success('Password reset successfully!');
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Password reset failed';
    yield put(editProfileFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* verifyMailSaga(action) {
  try {
    yield put(editProfileRequest());
    const response = yield call(profileApi.verifyMail, action.payload);
    yield put(editProfileSuccess(response.response));
    toast.success('Verification email sent successfully!');
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Email verification failed';
    yield put(editProfileFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* profileSaga() {
  yield takeEvery('EDIT_PROFILE_SAGA', editProfileSaga);
  yield takeEvery('GET_ADMIN_PROFILE_SAGA', getAdminProfileSaga);
  yield takeEvery('UPDATE_LOGO_SAGA', updateLogoSaga);
  yield takeEvery('CHANGE_PASSWORD_SAGA', resetPasswordSaga);
  yield takeEvery('VERIFY_MAIL_SAGA', verifyMailSaga);
}

export default profileSaga;